import Vue from "vue";
import Vuex from "vuex";
import Service from "../../../service/api.js";
import router from "../../../router/index.js";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {
        idp:{},
        method:[],
        course:[],

        objs:{
            isYourself : false,
            item:[]
        },

        isReload:false,

    },

    mutations: {
        idp(state, obj) {
            state.idp = obj;
        },

        method(state, obj) {
            state.method = obj;
        },
        course(state, obj) {
            state.course = obj;
        },

        objs(state, obj) {
            state.objs = obj;
        },

        isReload(state, obj) {
            state.isReload = obj;
        }
    },

    actions: {
        initByAccount({commit}, data) {
            Service.idp('init', data, {})
                .then((response) => {
                    // console.log(response)
                    // store.commit("idp/idp", response.data.data)
                }).catch((err) => {
            });
        },
        method({commit}, data) {
            return Service.idp_method('get', data, {})
                .then((response) => {
                    store.commit("idp/method", response.data.data)
                    return response
                }).catch((err) => {
                    throw err
            });
        },

        course({commit}, data) {
            return Service.idp_course('get', data, {})
                .then((response) => {
                    store.commit("idp/course", response.data.data)
                    return response
                }).catch((err) => {
                    throw err
            });
        },


        init({commit}, data) {
            Service.idp('post', data, {})
                .then((response) => {
                    store.commit("idp/idp", response.data.data)

                }).catch((err) => {
            });
        },
        explore({commit}, data) {
            Service.idp('explore', data, {})
                .then((response) => {

                    var objs = {};
                    objs.isYourself = data.isYourself;
                    objs.item = response.data.data;

                    store.commit("idp/objs", objs)
                }).catch((err) => {
            });
        },
        config({commit}, data) {
            store.commit("dialog/loading",true)
            Service.idp('put', data, {})
                .then((response) => {
                    // store.commit("idp/idp", response.data.data[0])
                    store.commit("dialog/loading",false)
                    store.commit("dialog/toasts",1)
                    store.commit("idp/isReload", true);
                }).catch((err) => {
                store.commit("dialog/loading",false)


                var message = { message: err.response.data.message.find(t => t.key === store.getters["setting/lang"]).value, code:err.response.data.code, number :"X", status:true};
                store.commit("dialog/dialog",message)
            });
        },

        changeAssessor({commit}, data) {
            store.commit("dialog/loading",true)
            Service.idp('change-assessor', data, {})
                .then((response) => {
                    store.commit("dialog/loading",false)
                    store.commit("dialog/toasts",1)
                }).catch((err) => {
                store.commit("dialog/loading",false)
            });
        },
    },

    getters: {
        idp(state, obj) {
            return state.idp;
        },

        method(state, obj) {
            return state.method;
        },
        course(state, obj) {
            return state.course;
        },

        objs(state, obj) {
            return state.objs;
        },

        isReload(state, obj) {
            return state.isReload;
        }
    },
};

export default ServerModule;
